<style>
    @import "./vip.less";
</style>

<template>
    <div class="lawinfring">
        <div class="lawinfring_con"></div>
        <div class="lawinfring_fr_content">
            <img src ="./lawcomponent/images/lawfring3.png" />
            <div class="lawinfring_fr_content_rig">
                <p class="rg_title">侵权下架</p>
                <p class="rg_tw_title">由专业律师提供各类合同的审核服务，单份合同限5000字以内</p>
                <p v-if="lawyerConsultNum>0" class="vipstyle">您是{{ userInfo.accountType == 'person' ? '个人' : '企业' }}VIP会员，当前剩余{{lawyerConsultNum}}次法律服务</p>
                <input @click="oneSubmit" class="goOrderEsc" type="button" value="立即下单" />
            </div>
        </div>
        <div class="lawinfring_parcontent" style="margin-bottom:80px">
            <div class="lawinfring_cont_title">
                <div>您可能还需要以下服务</div>
            </div>
            <div style="padding-top:339px">
                <lawCommon active-id="3" />
            </div>
        </div>
        <div class="lawinfring_three">
            <div class="law_thre_content">
                <p class="th_title">C<br />O<br />P<br />Y<br />R<br />I<br />G<br />H<br />T</p>
                <img src ="./lawcomponent/images/lawfring1.png" />
                <div class="th_thcontent">
                    <p style="margin-top:70px;" class="th_pf">发现侵权</p>
                    <p class="th_pf">时尚知识产权保护平台帮您批量多平台下架</p>
                    <p style="margin-top:30px;margin-bottom:15px;" class="th_ps">作品侵权，不知道如何让对方下架？</p>
                    <p class="th_ps">时尚知识产权保护平台可以为您提供侵权产品下架，维权，诉讼服务</p>
                </div>
            </div>
        </div>
        <div class="lawinfring_four" style="padding-top:53px;padding-bottom:80px">
            <lawcommontw :content="content" :title="title"/>
            <img src = "./lawcomponent/images/lawtele1.png" />
        </div>

        <!--    侵权下架模态框    -->
        <generalframe @fatherMethod="fatherMethod" v-show="showDialog" myheight="428" maintitle="侵权下架" ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>接听手机：</p>
                    <input v-model="callbackMobilePhone" style="flex:1" type="text" maxLength="11" placeholder="请输入11位手机号码" />
                </div>
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>下架链接：</p>
                    <input v-model="tortUrl" style="flex:1" type="text" placeholder="请输入下架链接" />
                </div>
                <div class="ts_content_fr">
                    <p>描述：</p>
                    <textarea v-model="questionDesc" style="flex:1;min-height:120px;resize: none;" placeholder="请输入您需要判定的简要描述"></textarea>
                </div>
                <input class="goOrderEsc" @click="this.sureOrder" type="button" value="确认下单" />
            </div>
        </generalframe>
        <!--    加油包    -->
        <monitorBag bizType="05" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
        <!--    会员续费    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>
    </div>
</template>

<script>
    import lawcommontw from './lawcomponent/lawcomponenttw.vue'
    import lawCommon from './lawcomponent/lawcomponentbl.vue'
    import generalframe from './lawcomponent/generalframe.vue'
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag'
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay'
    import Cookies from "js-cookie";
    import {getAddTortShelves,getVipMemberright} from '@/api/staticPage';
    import util from '@/libs/util';

    export default {
        metaInfo: {
            title: '侵权下架|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            },{
                name: 'Description',
                content: ''
            }]
        },
        name:'lawInfringing',
        components:{
            lawcommontw,
            lawCommon,
            generalframe,
            monitorBag,
            myczPay
        },
        data(){
            return {
                userInfo:Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                content:[
                    {content:'预约律师，确认下单',english:'ONE'},
                    {content:'等待律师，电话联系',english:'TWO'},
                    {content:'双方沟通，解答问题',english:'THREE'},
                    {content:'服务完成，平台回访',english:'FOUR'},
                ],
                title:'律师服务流程',
                lawyerConsultNum: 0, //法律服务剩余次数
                showDialog:!1,
                callbackMobilePhone:'', //手机号
                tortUrl:'', //下架链接
                questionDesc:'', //描述
                monitorBagState: false, //加油包模态框展示状态
                myczPayState: false //会员监测模态框展示状态
            }
        },
        methods:{
            _getAddTortShelves(){
                let _this = this;
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                let params = {
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    callbackMobilePhone:_this.callbackMobilePhone,
                    questionDesc:_this.questionDesc,
                    tortUrl:_this.tortUrl
                };
                getAddTortShelves(params).then(res=>{
                    console.log(res);

                    let message = res.message;
                    let _this = this;

                    //1.用户未实名；2.VIP未开通；3.VIP已到期；4.加油包

                    switch (res.code) {
                        case 200 : {
                            this.lawyerConsultNum = this.lawyerConsultNum - 1;
                            this.fatherMethod();
                            toast('提交成功！请前往【个人中心】查看订单服务详情')
                            break;
                        }
                        //未开通vip
                        case 214: {
                          toast("请购买产品后使用")
                          this.$router.push('/goods')
                          break;
                        }
                        //VIP已到期--弹框
                        case 215: {
                            /*toast(message, () => {
                                this.myczPayState = true;
                            });*/
                            toast("请购买产品后使用")
                            this.$router.push('/goods')
                            break;
                        }

                        //次数不够--弹出加油包
                        case 216 : {
                            this.monitorBagState = true;
                            break;
                        }

                        default:
                            toast(message);
                            break;

                    }

                }, (err) => {
                    toast('提交失败，请重试');
                })
            },

            /************服务次数接口***********/
            _getVipMemberright() {
                let _this = this;
                let userInfo = this.userInfo;

                if(userInfo && userInfo!='' && userInfo.vipFlag!=0){
                    let params = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                    };
                    getVipMemberright(params).then(res => {
                        if (res.code == 200) {
                            this.lawyerConsultNum = res.result.lawyerConsultNum;
                        }
                    })
                }

            },

            goOrder(){
                let _this = this;
                _this.showDialog = !0
            },

            fatherMethod() {
                let _this = this;
                _this.showDialog = !1;
                _this.callbackMobilePhone='';
                _this.tortUrl='';
                _this.questionDesc='';
            },

            /****************下单第一步**************/
            oneSubmit(){
                let userInfo = this.userInfo;
                if (userInfo == '') {
                    toast('请登录后再提交', () => {
                        this.$router.push({
                            path: '/'
                        });
                    });
                    return
                }
                this.goOrder();
            },

            /****************下单第二步**************/
            sureOrder(){
                let _this = this;

                if(!util.checkPhoneNum(_this.callbackMobilePhone)){
                    toast('请填写正确的手机号再提交');
                }
                else if(this.tortUrl=='' || this.questionDesc==''){
                    toast('请填写完整后再提交');
                }
                else{
                    _this._getAddTortShelves()
                }

            },

            /****************接收加油包组件传值**************/
            monitorBagFuc(value) {
                this.monitorBagState = false;
            },


            /****************接收会员续费组件传值**************/
            myczPayFuc() {
                console.log('会员续费弹框');
                this.myczPayState = false;
            },


        },
        mounted(){
            this._getVipMemberright();
        }
    }
</script>

<style scoped lang="less">
    .lawinfring{
        .ts_content{
            padding:30px;
            .ts_content_fr{
                display:flex;
                justify-content: flex-start;
                p{
                    width:70px;
                    text-align:left;
                    margin-right:10px;
                }
            }
        }
        .goOrderEsc{
            margin-top:20px;
            width:137px;
            height:42px;
            background:#121210;
            font-size:14px;
            font-weight:bold;
            color:#fff;
            line-height:42px;
            outline: none;
            border: none;
            cursor: pointer;
        }
        .lawinfring_con{
            height:360px;
            width: 100%;
            background:#121210;
        }
        .lawinfring_fr_content{
            width: 1334px;
            height: 518px;
            background: rgba(255, 255, 255, 1);
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            margin-top: -280px;
            z-index: 555;
            display: flex;
            justify-content: flex-start;
            img{
                width: 506px;
                height: 360px;
                display: block;
                margin: 32px 0 0 30px;
            }
            .lawinfring_fr_content_rig{
                margin-left:37px;
                .rg_title{
                    height:28px;
                    font-size:20px;
                    font-weight:bold;
                    color:rgba(65,65,65,1);
                    line-height:28px;
                    margin-top:40px;
                }
                .rg_tw_title{
                    height:20px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(65,65,65,1);
                    line-height:20px;
                    margin-top:10px;
                }
                input{
                    width:137px;
                    height:42px;
                    background:rgba(255,255,255,1);
                    border-radius:2px;
                    border:1px solid rgba(199,199,199,1);
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:42px;
                    cursor: pointer;
                    outline:none;
                    margin-right:20px;
                    margin-bottom:20px;
                    &:hover{
                        background:#121210;
                        border:none;
                    }
                }
                .active{
                    width:137px;
                    height:42px;
                    background:rgba(255,216,0,1);
                    border-radius:2px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:42px;
                    cursor: pointer;
                    outline:none;
                    border:none;
                    margin-right:20px;
                    margin-bottom:20px;
                }
                .vipstyle{
                    height:20px;
                    font-size:14px;
                    font-weight:bold;
                    color:#E82E31;
                    line-height:20px;
                    margin-top:200px;
                }
                .goOrderEsc{
                    margin-top:20px;
                    width:182px;
                    height:52px;
                    background:rgba(18,18,16,1);
                    font-size:18px;
                    color:#fff;
                    line-height:52px;
                    outline: none;
                    border: none;
                    cursor: pointer;
                }
            }
        }
        .lawinfring_parcontent{           
            .lawinfring_cont_title{
                width: 1334px;
                margin: 0 auto;
                position: relative;
                top: 185px;
                div{
                    position:absolute;
                    left:0;
                    right:0;
                    margin:auto;
                    z-index:3;
                    top:56px;
                    text-align:center;
                    font-size:30px;
                    font-weight:400;
                    color:rgba(4,4,4,1);
                    letter-spacing:3px;
                }
                p{
                    width:55px;
                    height:55px;
                    background:rgba(255,216,0,1);
                    border-radius:50%;
                    position:absolute;
                    left:0;
                    right:0;
                    margin:auto;
                    z-index:2;
                    top:50px;
                }
            }
        }
        .lawinfring_three{
            height: 450px;
            background: rgba(250, 252, 254, 1);
        }
        .law_thre_content{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 1334px;
            margin: 0 auto;
            height: 450px;
            overflow: hidden;
            .th_title{
                width:18px;
                height:306px;
                font-size:25px;
                font-family:Helvetica;
                color:rgba(51,51,51,0.2);
                line-height:30px;
            }
            img{
                width: 506px;
                height: 321px;
                margin-left: 17px;
                margin-right: 85px;
            }
            .th_thcontent{
                height:321px;
                .th_pf{
                    width:336px;
                    height:36px;
                    font-size:25px;
                    font-weight:400;
                    color:rgba(4,4,4,1);
                    line-height:36px;
                    letter-spacing:3px;
                }
                .th_ps{
                    height:21px;
                    font-size:15px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:21px;
                }
            }
        }
        .lawinfring_four{
            height:659px;
            width:1334px;
            margin:0 auto;
            display:flex;
            justify-content: flex-start;
            align-items: center;
            img{
                width:667px;
                height:456px;
            }
        }
    }
</style>